import { API_DOMAIN } from 'constants/infograph';
import { ErrorResponse } from 'libs/e2api/APIBackend';
import { useMemo } from 'react';
import { useLoaderData } from 'react-router-dom';
import useSWR, { mutate } from 'swr';

export const USER_GENERATIVE_API = `${API_DOMAIN}/getGenerateTextCredits`;

const fetcher = async (url: string, token: string) => {
  const headers = new Headers({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  });

  const response = await fetch(url, {
    method: 'GET',
    headers: Object.fromEntries(headers),
  });

  if (response.status >= 200 && response.status <= 299) {
    return response.json();
  } else {
    throw new ErrorResponse(response.status, response.statusText);
  }
};

export const useUserGenerativeLimit = (userId?: string): any => {
  const urlWithParams = userId ? `${USER_GENERATIVE_API}?user_id=${encodeURIComponent(userId)}` : null;
  const token = useLoaderData() as string;

  const { data, error } = useSWR(
    urlWithParams,
    () => {
      if (!urlWithParams) return;
      return fetcher(urlWithParams, token);
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    },
  );

  const refetch = () => mutate(urlWithParams);

  const result = useMemo(
    () => ({
      data,
      error,
      refetch,
    }),
    // Safe to not include refetch from dependencies list because its a setter and we do not change on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, error],
  );

  return result;
};
